<div class="modal-header">
    <h4 class="modal-title  pull-left">{{title}}</h4>
    <button type="button" class="close" data-dismiss="modal" (click)="bsModalRef.hide()">×</button>
  </div>
  <div class="modal-body">
    <div  *ngIf="list.length">
      <div   *ngFor="let item of list">
            <div class="form-row">
              <h5> {{ item[0]}}</h5>
            </div>
            <div class="form-row">
              <p class="details">{{item[1]}}</p>  
            </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close(true)">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
          <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
      </svg>&nbsp;{{closeBtnName}}
    </button>
  </div>
  